import { useAppSelector } from "redux/hooks";
import GoBack from "components/atoms/GoBack";
import Container from "@mui/material/Container";
import Banner from "components/templates/Banner";
import { useNavigate, useParams } from "react-router-dom";
import CircleLoader from "components/atoms/CircleLoader";
import AddQuotationForm from "./AddQuotationForm";
import UpdateQuotationForm from "./UpdateQuotationForm";
import QuotationService from "services/quotation.service";
import moment from "moment";
import ToasterService from "utils/toaster.util";

export default function AddQuotation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.formLoader.loading);



  
  const handleSubmit = async (values: any) => {
    const data = { ...values }
    data.language = 'English'
    // data.language = data.language ? 'English' : 'Arabic'
    data.bookings = data?.bookings?.map((item: any) => {
      let booking = { ...item }
      if (booking.start_date) booking.start_date = booking.start_date?.date ? moment(booking.start_date?.date).format() : null
      if (booking.end_date) booking.end_date = booking.end_date?.date ? moment(booking.end_date?.date).format() : null
      if (booking.pickup) {
        console.log(booking.pickup, "booking.pickup");
        booking.pickup_details = {
          place_id: booking.pickup?.details?.place_id,
          address: booking.pickup?.value,
          airport: booking.pickup?.details?.airport,
          coordinates: {
            lat: booking.pickup?.details?.geometry?.location?.lat,
            lng: booking.pickup?.details?.geometry?.location?.lng,
          },
        };
        booking.pickup = booking.pickup?.value
      }
      if (booking.destination) {
        booking.destination_details = {
          place_id: booking.destination?.details?.place_id,
          address: booking.destination?.value,
          airport: booking.destination?.details?.airport,
          coordinates: {
            lat: booking.destination?.details?.geometry?.location?.lat,
            lng: booking.destination?.details?.geometry?.location?.lng,
          },
        };
        booking.destination = booking.destination?.value 
      }

      return booking
    }) || []

    const booking=data.bookings
    const totalTax = booking.reduce((sum: number, item: any) => sum + Number(item.tax), 0);
    const allSameTax = booking.every((item: any) => Number(item.tax) === totalTax / booking.length);
    
    if (!allSameTax) {
      ToasterService.showError("Please make sure all fields have the same tax value.")
      return
    }
        
    if (id) QuotationService.updateQuotation(id, data, navigate)
    else QuotationService.addQuotation(data, navigate)

  };

  return (
    <div>
      <Container>
        <GoBack path="/rfqs" title="Back to Quotations" />
        <Banner heading={`${id ? "Update" : "Add"} Quotation`} />
        <div className="form">
          {loading && <CircleLoader />}

          <AddQuotationForm onSubmit={handleSubmit} />

          {id && <UpdateQuotationForm id={id} />}
        </div>
      </Container>
    </div>
  );
}
